import { publicData } from '@/api/index'

export function getInterval (data, params) {
  const extendUrl = params.urlParam ? '?' + params.urlParam : ''
  return publicData.request({
    method: 'post',
    url: '/Getinterval' + extendUrl
  })
}

export function getIntervalNoAll (data, params) {
  const extendUrl = params.urlParam ? '?' + params.urlParam : ''
  return publicData.request({
    method: 'post',
    url: '/GetintervalNoAll' + extendUrl,
    data
  })
}

export function publicDataDecryptColumn (data) {
  return publicData.request({
    method: 'post',
    url: '/PubilcDataDecryptColumn',
    data
  })
}

export function checkOutexcel (data) {
  return publicData.request({
    method: 'post',
    url: '/checkOutexcel',
    data
  })
}

export function DownLoadExportExcel (data) {
  return publicData.request({
    method: 'post',
    url: '/DownLoadExportExcel',
    data,
    iSFromData: true
  })
}
export function downLoadExportExcel2 (data) {
  return publicData.request({
    method: 'post',
    url: '/DownLoadExportExcel2',
    data,
    iSFromData: true
  })
}

export function getSite (data) {
  return publicData.request({
    method: 'post',
    url: '/GetSite',
    data,
    iSFromData: true
  })
}

export function GetSiteRole (data) {
  return publicData.request({
    method: 'post',
    url: '/GetSiteRole',
    data
  })
}
export function GetFeetype (data) {
  return publicData.request({
    method: 'post',
    url: '/GetFeetype',
    data
  })
}

export function downLoadExportExcel (data) {
  return publicData.request({
    method: 'post',
    url: '/DownLoadExportExcel',
    data,
    iSFromData: true
  })
}

export function downLoadExportExcel3 (data) {
  return publicData.request({
    method: 'post',
    url: '/DownLoadExportExcel3',
    data,
    iSFromData: true
  })
}

export function PubilcDataDecrypt (data) {
  return publicData.request({
    method: 'post',
    url: '/PubilcDataDecrypt',
    data
  })
}
export function Getusername (data, params) {
  const extendUrl = params.urlParam ? '?' + params.urlParam : ''
  return publicData.request({
    method: 'post',
    url: '/Getusername',
    data,
    iSFromData: true
  })
}
